import React from 'react';
import { Box, Split } from '@dropbox/dig-foundations';
import styles from './chip-buttons-wrapper.module.css';

type ChipButtonsWrapperProps = {
  children: React.ReactNode;
};
export default function ChipButtonsWrapper({
  children,
}: ChipButtonsWrapperProps) {
  return (
    <Box className={styles.chipButtonsWrapper} position={'absolute'}>
      <Split gap={'Micro Medium'}>
        {React.Children.map(children, (child) => (
          <Split.Item>{child}</Split.Item>
        ))}
      </Split>
    </Box>
  );
}
